(($) => {

	// ========================================================
	// GLOBALS
	// ========================================================

	const Globals = {
		// Variables
		$body: $('body'),
		$window: $(window),
		$document: $(document),
		// Methods
		addMobileDetection: function() {
			// @link https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
			if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
				this.$body.addClass('is-mobile');
			}
		},
		add: function(key, val) {
			this[key] = val;
		}
	}

	Globals.addMobileDetection();

	Globals.add('sliders', {
		nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M1.6 1.4 8 7l-6.4 5.6"/></svg></button>`,
		prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.4 12.6 2 7l6.4-5.6"/></svg></button>`,
	});

	// ========================================================
	// INCLUDE PARTIAL FILES VIA GULP-INCLUDE
	// ========================================================

	/**
	 * Main website navigation menu.
	 * Utilizes 3rd party accessible menu solution.
	 *
	 * @link https://accessible-menu.dev/
	 */
	const NavMenu = (function() {
		const module = {
			/**
			 * Module options
			 */
			_opts: {
				selectors: {
					menu: '.navbar__menu',
					submenu: '.sub-menu',
					submenuToggle: '.sub-menu-toggle',
				}
			},
			/**
			 * Internal storage
			 */
			_data: {
				menuToggles: {},
			},
			/**
			 * The menu object
			 */
			_menu: {},
			/**
			 * Submenu observer for detecting changes
			 */
			_subMenuObserver: {},
			/**
			 * Main initialization function
			 */
			init: function() {
				// Setup menu
				this.setupMenu();
				// Setup submenu observer
				this.setupSubMenuObserver();
				// Setup menu item hover events
				this.setupMenuItemHoverEvents();
				// Build menu toggler
				this.buildMenuToggler(this._menu._elements);
				// Add menu item images
				$(`${this._opts.selectors.submenu} > li`).each((this.addMenuItemImages.bind(this)));
				// Add submenu headers
				$(`${this._opts.selectors.submenu}:not(.faux)`).each((this.addSubMenuHeaders.bind(this)));
				// Submenu header click
				$(document).on('click', '.sub-menu-header', this.handleSubMenuHeaderClick.bind(this));
				// Observe submenus
				$(`${this._opts.selectors.submenu} ${this._opts.selectors.submenu}`).each(this.observeSubMenus.bind(this));
			},
			/**
			 * Setup the Accessible Menu library.
			 *
			 * Using the TopLinkDisclosureMenu type so nav links can be links instead
			 * of only submenu toggles.
			 */
			setupMenu: function() {
				// @link https://accessible-menu.dev/top-link-disclosure-menus.html
				this._menu = new AccessibleMenu.TopLinkDisclosureMenu({
					menuElement: document.querySelector(this._opts.selectors.menu),
					controllerElement: document.querySelector('.navbar__toggler'),
					containerElement: document.querySelector('.navbar__nav'),
					submenuSubtoggleSelector: 'button',
					hoverType: 'on',
				})
			},
			/**
			 * Setup the submenu MutationObserver class
			 */
			setupSubMenuObserver: function() {
				const module = this;
	
				this._subMenuObserver = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						const $submenu = $(mutation.target);
						if ($submenu.hasClass('show')) {
							module.setMenuImageAllowance($submenu);
						}
					});
				});
			},
			/**
			 * Recursive function for grabbing all submenu toggle elements out of
			 * our menu object. Handy for interacting with these and closing submenus
			 * programmatically.
			 *
			 * @param {object} elements The menu elements
			 */
			buildMenuToggler: function(elements) {
				const module = this;
	
				// Main/root menu
				if (elements.submenuToggles.length) {
					elements.submenuToggles.forEach((toggle, i) => {
						const key = $(toggle._dom.toggle).attr('id');
						module._data.menuToggles[key] = toggle
					})
				}
				// All other submenus
				elements.menuItems.forEach((val, i) => {
					if (val.isSubmenuItem) {
						// Grab the toggles
						val._elements.childMenu._elements.submenuToggles.forEach((toggle, i) => {
							const key = $(toggle._dom.toggle).attr('id');
							module._data.menuToggles[key] = toggle
						})
						// Keep going
						module.buildMenuToggler(val._elements.childMenu._elements);
					}
				});
			},
			/**
			 * Add menu item images as new list items.
			 *
			 * @param {integer} i
			 * @param {domElement}} menuItem
			 */
			addMenuItemImages: function(i, menuItem) {
				const $menuItem = $(menuItem);
				const menuItemLink = $menuItem.find('>a').attr('href');
				const $childMenu = $menuItem.find(this._opts.selectors.submenu);
				const listItemMarkup = `<li class="menu-item menu-item--image"><a href="${menuItemLink}"><span class="visually-hidden">View All</span></a></li>`;
	
				// If a list item has submenus, add image as new list item at end
				if ($childMenu.length) {
					$childMenu.append(listItemMarkup);
				// Otherwise, create a fake submenu just to add the list item image
				} else if ($menuItem.hasClass('menu-item--has-image')) {
					$menuItem.append(`<ul class="sub-menu faux">${listItemMarkup}</ul>`);
				}
			},
			/**
			 * Set a menu image's height allowance.
			 * This gets used for a pseudo element to make sure submenus
			 * don't spill out of their parent container.
			 *
			 * @param {JQuery} $subMenu
			 */
			setMenuImageAllowance: function($subMenu) {
				const menuHeight = $subMenu.outerHeight();
				const containerHeight = $subMenu.parents(this._opts.selectors.submenu).height();
				const $parentSubMenu = $subMenu.parents(this._opts.selectors.submenu);
				const allowance = menuHeight - containerHeight;
				$parentSubMenu.css('--menu-image-allowance', `${allowance > 0 ? Math.round(allowance) : 0}px`);
			},
			/**
			 * Add submenu headers so we can toggle the mobile menu "pages".
			 *
			 * @param {boolean} i Index
			 * @param {domElement} submenu The submenu we are adding the header to
			 */
			addSubMenuHeaders: function(i, submenu) {
				const $this = $(submenu);
				const text = $this.siblings('a').text();
				$this.prepend(`<li class="sub-menu-header">${text}</li>`);
			},
			/**
			 * Handle submenu header clicks.
			 * Basically, just closes the submenu.
			 * This is why we assembled all the menuToggles for easy access here!
			 *
			 * @param {domElement} subMenuHeader The submenu header element
			 */
			handleSubMenuHeaderClick: function(subMenuHeader) {
				const $this = $(subMenuHeader.currentTarget);
				const target = $this.parent().siblings(this._opts.selectors.submenuToggle).attr('id');
				this._data.menuToggles[target].close();
			},
			/**
			 * Observe all submenu elements so we can tel when DOM changes happen.
			 *
			 * @param {integer} i Index
			 * @param {domElement} submenu The submenu to observe
			 */
			observeSubMenus: function(i, submenu) {
				this._subMenuObserver.observe(submenu, {
					subtree: false,
					childList: false,
					attributes: true,
				});
			},
			/**
			 * Setup hover events on our menu items.
			 */
			setupMenuItemHoverEvents: function() {
				// Top level menu items hover
				$(`${this._opts.selectors.menu} > li`).on('mouseenter', e => {
					const $listItem = $(e.currentTarget);
					$listItem.find(`${this._opts.selectors.submenu} > .menu-item:nth-child(2)`).first().addClass('js-hover');
					this.setMenuImageAllowance($listItem.find(`${this._opts.selectors.submenu} ${this._opts.selectors.submenu}`));
				}).on('mouseleave', e => {
					$(e.currentTarget).find(`${this._opts.selectors.submenu} > .menu-item:nth-child(2)`).first().removeClass('js-hover');
				});
	
				// Sub menu item hover (.sub-menu .sub-menu)
				$(`${this._opts.selectors.menu} ${this._opts.selectors.submenu} > li`).on('mouseenter', e => {
					$(e.currentTarget).addClass('js-hover');
				}).on('mouseleave', e => {
					$(e.currentTarget).removeClass('js-hover').siblings().removeClass('js-hover');
				});
			}
		};
	
		// Self init
		module.init();
	})();
	
	/**
	 * Main accordion parent block
	 */
	$('.accordion').each((i, el) => {
		const $accordion = $(el);
		const id = 'accordion-' + Math.random().toString(16).slice(2);
	
		// Add an ID to the block
		$accordion.attr('id', id);
	
		// Add the parent block ID to the accordion items so that only one is open at a time
		$accordion.find('.accordion-collapse').attr({
			'data-bs-parent': `#${id}`
		});
	});
	
	/**
	 * Accordion item blocks
	 */
	$('.accordion-item').each((i, el) => {
		const $item = $(el);
		const id = 'accordion-item-' + Math.random().toString(16).slice(2);
	
		// Add attributes to the toggle button
		$item.find('.accordion-button').attr({
			'data-bs-target': `#${id}`,
			'aria-controls': id
		});
	
		// Add id to the collapse container
		$item.find('.accordion-collapse').attr({
			'id': `${id}`
		});
	});
	
	
		// $('.block-gallery-item img').each((i, img) => {
	// 	const $img = $(img);
	// 	const url = $img.data('image-url');
	// 	const $parent = $img.parents('.block-slider');
	// 	const fbAtt = $parent.length ? `data-fancybox="${$parent.attr('id')}"` : 'data-fancybox';
	// 	const caption = $img.data('caption');
	
	// 	$img.wrap(`<a ${fbAtt} data-caption="${typeof caption !== 'undefined' ? caption : ''}" href="${url}"></a>`);
	// });
	
		const InteractiveMap = function($selector) {
		const module = {
			opts: {
				$module: $selector,
				// Style from snazzymaps.com -> based off style "Subtle Grayscale" by Paulo Avila
				styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#f1edea"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b8c4c7"}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
				selectors: {}
			},
			map: {},
			bindEvents: function() {},
			init: function() {
				this.map = this.initMap();
				this.initMarkers();
				this.centerMap();
			},
			initMap: function() {
				const { $module, styles } = this.opts;
				const map = new google.maps.Map( $module[0], {
					zoom : $module.data('zoom') || 4,
					mapTypeId : 'roadmap', // google.maps.MapTypeId.ROADMAP,
					center: { lat: -25.344, lng: 131.031 },
					disableDefaultUI: true,
					styles
				});
				return map;
			},
			initMarkers: function() {
				this.map.markers = [];
				this.opts.$module.data('markers').forEach(marker => this.addMarker(marker));
			},
			addMarker: function(data) {
				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat( data['lat'] ),
						lng: parseFloat( data['lng'] )
					},
					icon: '/wp-content/themes/baker-home-exteriors/dist/images/icons/pin.svg',
					map: this.map
				});
	
				// Append to reference for later use.
				this.map.markers.push( marker );
	
				// If marker contains HTML, add it to an infoWindow.
				if( data.name.length ){
	
					// Create info window.
					const infowindow = new google.maps.InfoWindow({
						content: data.name
					});
	
					// Show info window when marker is clicked.
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.open( this.map, marker );
					});
				}
			},
			centerMap: function() {
				const bounds = new google.maps.LatLngBounds();
				this.map.markers.forEach(function( marker ){
					bounds.extend({
						lat: marker.position.lat(),
						lng: marker.position.lng()
					});
				});
	
				// Case: Single marker.
				if( this.map.markers.length == 1 ){
					this.map.setCenter( bounds.getCenter() );
	
				// Case: Multiple markers.
				} else{
					this.map.fitBounds( bounds );
				}
			}
		}
	
		if ($selector.length && typeof google !== 'undefined') {
			module.init();
		}
	
		return module;
	}
	
	
	/**
	 * Register after jQuery doc ready
	 */
	$(() => {
		new InteractiveMap($('.map-element'));
	});
	
		$(() => {
		$('.block-page-header.has-ken-burns-animation').addClass('animate');
		$('.block-page-header.has-fade-in-animation').addClass('animate');
	})
	
		/**
	 * Loads parent section images for cross fading.
	 *
	 * @param {JQuery} $slider
	 * @returns void
	 */
	const loadSectionImages = ($slider) => {
		const $sliderParentBlock = $slider.parents('.block-slider-basic'); // slider parent section
		const $parentSection = $slider.parents('.block-section'); // top most parent section
		const images = $sliderParentBlock.data('slide-images');
		const breakpoint = '768px';
		let $targetDiv;
	
		if (typeof images === 'undefined' || images.length === 0) return;
	
		$parentSection.append('<div class="block-section__background"></div>')
			.removeClass('has-default-margin')
			.removeClass('has-zero-padding')
			.addClass('has-zero-margin');
	
		images.forEach((img, i) => {
			$parentSection.find('.block-section__background').append(`<picture>
				<source srcset="${img['desktop']}" media="(min-width:${breakpoint})" />
				<img src="${img['mobile']}" style="display:none;" alt="" />
			</picture>`);
		});
	}
	
	/**
	 * Updates the active section background.
	 *
	 * @param {JQuery} $slider
	 * @param {int} imageIndex
	 */
	const updateSectionBackground = ($slider, imageIndex) => {
		const $sliderParentBlock = $slider.parents('.block-slider-basic'); // slider parent section
		const $parentSection = $slider.parents('.block-section'); // top most parent section
		const $target = $parentSection.find('.block-section__background');
		const delay = 400;
	
		$target.find('img').fadeOut(delay);
		$target.find('img').eq(imageIndex).fadeIn(delay);
	};
	
	/**
	 * Initializes all sliders.
	 * All sliders have option to sync images with parent div. This will cause
	 * the slider to update the div on the background.
	 */
	$('.basic-slider').each((i, el) => {
		const $el = $(el);
		const $sliderEl = $el;
		const numSlides = $sliderEl.find('.slide').length;
		const $controls = $sliderEl.next('.js-slider-controls');
		const { nextArrow, prevArrow } = Globals.sliders;
	
		let config = {
			dots: numSlides > 1,
			nextArrow,
			prevArrow,
			appendArrows: $controls,
			appendDots: $controls,
		};
	
		const $slider = $sliderEl.on('init', (e, slick) => {
			loadSectionImages($sliderEl);
			updateSectionBackground($sliderEl, 0);
		}).on('afterChange', (e, slick, currentSlide) => {
			updateSectionBackground($sliderEl, currentSlide);
		}).slick(config);
	
	});
	
	
		/**
	 * Slider
	 */
	$('.block-slider-gallery').each((i, el) => {
		const $block = $(el);
		const $sliderEl = $block.find('.gallery-slider');
		const { nextArrow, prevArrow } = Globals.sliders;
		const isMobileOnlySlider = $block.hasClass('has-slider-type-mobile');
		const $controls = $sliderEl.next('.js-slider-controls');
		const breakpoint = 768;
		let $galleryItems;
		let $slides;
	
		// Default config - slider for both desktop and mobile
		let config = {
			dots: true,
			nextArrow,
			prevArrow,
			fade: true,
			appendArrows: $controls,
			appendDots: $controls,
			responsive: [
				{
					breakpoint,
					settings: {
						fade: false
					}
				}
			]
		};
	
		// Mobile only config - slider only on mobile
		if (isMobileOnlySlider) {
			$galleryItems = $sliderEl.find('.gallery-item');
			$slides = $galleryItems.children();
			config = {
				mobileFirst: true,
				dots: true,
				nextArrow,
				prevArrow,
				appendArrows: $controls,
				appendDots: $controls,
				responsive: [
					{
						breakpoint,
						settings: 'unslick'
					}
				]
			}
	
			// Change markup to remove slide wrappers for mobile
			if (Globals.$window.width() <= breakpoint) {
				// Mobile
				$sliderEl.empty().append($slides);
			} else {
				// Desktop
				$sliderEl.empty().append($galleryItems);
			}
		}
	
		// Initialize
		const $slider = $sliderEl.slick(config);
	
		// Controls
		// const $controls = $sliderEl.next('.js-slider-controls');
		// $slider.slick('setOption', 'appendDots', $controls, true);
		// $slider.slick('setOption', 'appendArrows', $controls, true);
	
		// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
		if ($slider.find('.slick-track').length === 0) {
			$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
			$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
		}
	
	});
	
		$('.grid-slider').each((i, el) => {
		const $el = $(el);
		const $sliderEl = $el;
		const { nextArrow, prevArrow } = Globals.sliders;
		const numSlides = $sliderEl.find('.slide').length;
		const $filler = $sliderEl.find('.block-filler-card');
		const $controls = $sliderEl.next('.js-slider-controls');
	
		let config = {
			dots: numSlides <= 6,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '20px',
			mobileFirst: true,
			nextArrow,
			prevArrow,
			appendArrows: $controls,
			appendDots: $controls,
			responsive: [
				{
					breakpoint: 768,
					settings: 'unslick'
				}
			]
		};
	
		const $slider = $sliderEl.slick(config);
	
		// Remove any filler cards
		if ($filler.length) {
			const lastSlide = $sliderEl.find('.slide:not(.slick-cloned)').length;
			$slider.slick('slickRemove', lastSlide);
		}
	
		// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
		if ($slider.find('.slick-track').length === 0) {
			$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
			$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
		}
	
	});
	
		if (typeof countUp !== 'undefined') {
		$('.stat p:first-child').each((i, el) => {
			const $this = $(el);
	
			// First, replace any commas
			$this.text($this.text().replace(/\,/g, ''));
	
			// Next wrap numbers in span
			$this.html($this.text().replace(/(\d+)(.?)$/g, `<span class="number">$1</span>$2`));
	
			// Init count up library
			const statCounter = new countUp.CountUp($this.find('.number').get(0), $this.find('.number').text(), {
				separator: ',',
				enableScrollSpy: true,
				scrollSpyDelay: i * 200,
				scrollSpyOnce: true,
			});
		});
	}
	

	// ========================================================
	// FANCYBOX
	// ========================================================

	/**
	 * Full screen popup
	 */
	$('a[href="#popupForm"]').fancybox({
		baseClass: 'fancybox-fullscreen-popup-form',
		touch: false,
	});

	/**
	 * Default close button for all Fancybox popups
	 */
	$.fancybox.defaults.buttons = ['close'];
	$.fancybox.defaults.hash = false;
	$.fancybox.defaults.btnTpl.arrowLeft = `
		<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
			<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.4 12.6 2 7l6.4-5.6"/></svg></div>
		</button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `
		<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
			<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M1.6 1.4 8 7l-6.4 5.6"/></svg></div>
		</button>`;

	// ========================================================
	// GRAVITY FORMS FLOATING LABELS
	// - Using Bootstrap 5's floating labels
	// - @link https://getbootstrap.com/docs/5.3/forms/floating-labels/
	// ========================================================

	const fields = [
		'.gfield--type-text label',
		'.gfield--type-phone label',
		'.gfield--type-email label',
		'.gfield--type-name label',
		'.gfield--type-select label',
		'.gfield--type-textarea label',
		'.gfield--type-address .ginput_address_line_1 label',
		'.gfield--type-address .ginput_address_city label',
		'.gfield--type-address .ginput_address_zip label',
	];

	function initFloatingLabels(formId) {
		// All field labels
		$(`#gform_${formId}`).find(fields.join(',')).each((i, el) => {
			const $label = $(el);
			const $field = $label.parents('.gfield');
			let $container = $label.next('.ginput_container');

			// Complex fields (i.e. name or address fields)
			if ($field.hasClass('gfield--type-name') || $field.hasClass('gfield--type-address')) {
				$container = $label.parent();
			}

			// Return if already initialized (i.e. label already moved)
			if ($container.length === 0) {
				return;
			}

			// Add Bootstrap class (except select boxes)
			if (!$field.hasClass('gfield--type-select')) {
				$container.addClass('form-floating');
			}

			// Move label into correct position
			$label.remove().appendTo($container);
		});
		// Special handling for select forms only on change event
		$('.gfield--type-select select, .ginput_address_country select, .ginput_address_state select').on('change', e => {
			$(e.currentTarget).parent().addClass('form-floating');
		});
	}

	// Init floating labels on page load
	$('.gform_wrapper form').each((i, el) => initFloatingLabels($(el).data('formid')));

	// Gravity forms post render hook to reinit after validation or paging
	$(document).on('gform_post_render', function (event, form_id, current_page) {
		initFloatingLabels(form_id);
	});


	// ========================================================
	// PARAGRAPH TAGS - MAX WORD COUNT
	// Adds a class so we can left align for mobile
	// ========================================================

	$('p').each((i, el) => {
		const $this = $(el);
		const wordCount = $this.text().trim().split(/\s+/).length;
		const maxWords = 35;

		if (wordCount > maxWords) {
			$this.addClass('js-wc-over-35');
		}
	});


	// ========================================================
	// ADD ANCHOR LINKS FOR WP BLOCKS
	// - This is so we can control the jump positioning
	// ========================================================

	$('.wp-block-media-text[id]').each((i, el) => {
		const $this = $(el);
		const id = $this.attr('id');

		// Move anchor for any screens above WP mobile breakpoint
		if (Globals.$window.width() > 600) {
			$this.removeAttr('id');
			$this.find('.wp-block-media-text__content').prepend(`<a name="${id}" class="anchor"></a>`)
		}
	});


})(jQuery);
